// extracted by mini-css-extract-plugin
export var active = "PartnerSectionNav-module__active___pvQGV";
export var link = "PartnerSectionNav-module__link___Vnbk5";
export var list = "PartnerSectionNav-module__list___bgMC8";
export var nav = "PartnerSectionNav-module__nav___rHIyQ";